module.exports = __webpack_public_path__ + "static/media/youssef_nn.9385e46f.jpg";